import { getBugModalState } from "../store/components";
import * as theme from "../theme";
import BugReport from "../bugreport/BugReport";
import Modal from "react-modal";
import { useSelector } from "react-redux";

const BugModal = () => {
  const bugModalState = useSelector(getBugModalState);

  return (
    <Modal
      isOpen={bugModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "90vh",
          width: "90vw",
          position: "absolute",
          top: "7vh",
          left: "5vw",
          right: 0,
          bottom: 0,
          background: theme.COLORS.tertiary_ligthindigo,
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <BugReport></BugReport>
    </Modal>
  );
};

export default BugModal;
